var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-img"}),_c('div',{staticClass:"error-text"},[_vm._v(_vm._s(_vm.warningText))]),_c('div',{staticClass:"back-home",on:{"click":_vm.backHome}},[_vm._v("返回首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }